"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateLeadsProduct = exports.getLeadsProducts = exports.getLeadsProductById = exports.deleteLeadsProduct = exports.defaultLeadsProductData = exports.createLeadsProduct = exports.addLeadsProducts = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultLeadsProductData = exports.defaultLeadsProductData = {
  id: 0,
  enabled: true,
  leadId: null,
  productId: null,
  productsVariationId: null,
  quantity: 1,
  salePrice: 0,
  unitPrice: 1,
  subTotal: 0,
  total: 0,
  taxId: null,
  taxAmount: 0,
  taxRate: 0,
  discount: 0,
  discountAmount: 0
};
const getLeadsProducts = params => (0, _request.default)({
  url: '/leads-products',
  method: 'get',
  params
});
exports.getLeadsProducts = getLeadsProducts;
const getLeadsProductById = id => (0, _request.default)({
  url: `/leads-products/${id}`,
  method: 'get'
});
exports.getLeadsProductById = getLeadsProductById;
const updateLeadsProduct = (id, data) => (0, _request.default)({
  url: `/leads-products/${id}`,
  method: 'patch',
  data
});
exports.updateLeadsProduct = updateLeadsProduct;
const deleteLeadsProduct = id => (0, _request.default)({
  url: `/leads-products/${id}`,
  method: 'delete'
});
exports.deleteLeadsProduct = deleteLeadsProduct;
const createLeadsProduct = data => (0, _request.default)({
  url: '/leads-products/',
  method: 'post',
  data
});
exports.createLeadsProduct = createLeadsProduct;
const addLeadsProducts = data => (0, _request.default)({
  url: '/leads-products/add',
  method: 'post',
  data
});
exports.addLeadsProducts = addLeadsProducts;